// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Amigo-log',
  intro:
    'Elk verzoek dat Amigo heeft afgehandeld: wat er gevraagd is, waar, wie het vroeg en wie het goedkeurde. Alleen FoodAmigos ziet deze pagina.',
  // The tab list's name for screen readers.
  tabs_label: 'Amigo-log',
  tabs: {
    requests: 'Verzoeken',
    gaps: 'Niet gelukt',
  },
  filters: {
    restaurant: 'Restaurant',
    all_restaurants: 'Alle restaurants',
    brand: '{{name}} · Merk',
    restaurant_unknown: 'Restaurant {{id}}',
    searching: 'Restaurants zoeken…',
    no_restaurant: 'Geen restaurant met de naam „{{query}}”',
    period: 'Periode',
    start_date: 'Startdatum',
    end_date: 'Einddatum',
    refresh: 'Vernieuwen',
    gap: 'Gevraagd: {{request}}',
    change_set: 'Het verzoek achter één wijziging',
    remove: 'Filter verwijderen: {{label}}',
    clear: 'Filters wissen',
  },
  columns: {
    steps: 'Stappen',
    when: 'Wanneer',
    request: 'Verzoek',
    restaurant: 'Restaurant',
    asked_by: 'Gevraagd door',
    result: 'Resultaat',
  },
  show_steps: 'Stappen tonen van: {{request}}',
  approved_by: 'Goedgekeurd door {{name}}',
  nothing_approved: 'Niets goedgekeurd',
  results: {
    applied: '{{applied}} toegepast',
    applied_skipped: '{{applied}} toegepast · {{skipped}} overgeslagen',
    partial: '{{applied}} van {{total}} toegepast',
    imported: 'Geïmporteerd',
    importing: 'Importeren',
    waiting: 'Wacht op goedkeuring',
    rejected: 'Afgewezen',
    undone: 'Ongedaan gemaakt',
    partly_undone: '{{undone}} van {{total}} ongedaan gemaakt',
    expired: 'Verlopen',
    replaced: 'Vervangen',
    failed: 'Mislukt',
    answered: 'Beantwoord',
    not_yet: 'Nog niet gelukt',
    off_limits: 'Niet toegestaan',
    not_allowed: 'Niet toegestaan',
    switched_off: 'Uitgeschakeld',
    guard: 'Gestopt door een veiligheidscontrole',
    not_found: 'Niet gevonden',
  },
  steps: {
    asked: '{{name}} vroeg',
    asked_anonymous: 'Gevraagd',
    approved: 'Goedgekeurd door {{name}}',
    approved_alone: 'Goedgekeurd',
    applied_one: '{{count}} wijziging toegepast',
    applied_other: '{{count}} wijzigingen toegepast',
    failed_one: '{{count}} niet toegepast',
    failed_other: '{{count}} niet toegepast',
    rejected: 'Afgewezen',
    undone: 'Ongedaan gemaakt',
    undone_by: 'Ongedaan gemaakt, goedgekeurd door {{name}}',
    skipped_one: '{{count}} overgeslagen',
    skipped_other: '{{count}} overgeslagen',
    skipped_state: 'Overgeslagen',
    more_one: 'en nog {{count}}',
    more_other: 'en nog {{count}}',
    changes_one: '{{count}} wijziging',
    changes_other: '{{count}} wijzigingen',
    other: 'Iets controleren',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} stap',
    steps_other: '{{count}} stappen',
    refused_one: '{{count}} geweigerd',
    refused_other: '{{count}} geweigerd',
    failed_one: '{{count}} mislukt',
    failed_other: '{{count}} mislukt',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Resultaat',
    answered: 'Een antwoord: niets gewijzigd.',
    waiting: 'Wacht op goedkeuring. Nog niets gewijzigd.',
    rejected: 'Afgewezen: niets gewijzigd.',
    expired: 'Verlopen zonder goedkeuring: niets gewijzigd.',
    replaced: 'Vervangen door een nieuwere kaart: hier is niets gewijzigd.',
    undone: 'Ongedaan gemaakt: de wijzigingen zijn teruggedraaid.',
    partly_undone: 'Gedeeltelijk ongedaan gemaakt: {{undone}} van {{total}} wijzigingen zijn teruggedraaid.',
    failed: 'Mislukt: niets gewijzigd.',
    not_yet: 'Nog niet mogelijk: niets gewijzigd. Telt mee bij Niet gelukt.',
    off_limits: 'Niet toegestaan: niets gewijzigd.',
    not_allowed: 'Niet toegestaan voor de rol van deze persoon: niets gewijzigd.',
    switched_off: 'Hier uitgeschakeld: niets gewijzigd.',
    guard: 'Gestopt door een veiligheidscontrole: niets gewijzigd.',
    not_found: 'Niet gevonden: niets gewijzigd.',
    importing: 'Importeren. Elk gerecht komt in Menu → Bewerkingsgeschiedenis.',
    imported: 'Geïmporteerd. Elk gerecht staat in Menu → Bewerkingsgeschiedenis.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} wijziging',
    title_other: '{{count}} wijzigingen',
    show_all: 'Alle {{count}} wijzigingen tonen',
    show_fewer: 'Minder tonen',
    from: 'van',
    to: 'naar',
    removed: 'Verwijderd',
  },
  row_states: {
    skipped: 'Overgeslagen',
    failed: 'Niet toegepast',
    stale: 'Intussen gewijzigd',
    kept: 'Ongewijzigd gelaten',
  },
  menu_history: 'Open Menu → Bewerkgeschiedenis',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Chat openen',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: 'Dat restaurant kon niet worden geopend. Probeer het opnieuw.',
  pagination: {
    label: "Pagina's",
    summary: '{{from}}–{{to}} van {{total}} verzoeken',
    previous: 'Vorige pagina',
    next: 'Volgende pagina',
  },
  empty: {
    title: 'Geen verzoeken voor {{restaurant}} in deze periode',
    text: 'Amigo heeft daar tussen {{from}} en {{to}} niets afgehandeld.',
    title_any_day: 'Nog geen verzoeken voor {{restaurant}}',
    text_any_day: 'Amigo heeft daar nog niets afgehandeld.',
    title_everywhere: 'Geen verzoeken in deze periode',
    text_everywhere: 'Amigo heeft tussen {{from}} en {{to}} niets afgehandeld.',
    title_nothing: 'Nog geen verzoeken',
    text_nothing: 'Amigo heeft nog niets afgehandeld.',
  },
  loading: 'Laden…',
  error: {
    title: 'Het log kon niet worden geladen',
    text: 'Probeer het zo meteen opnieuw.',
    retry: 'Opnieuw proberen',
  },
  gaps: {
    intro:
      'Wat Amigo nog niet kon, gegroepeerd op wat er gevraagd is, het meest gevraagd eerst. Verzoeken die niet mogen en verzoeken die een rol niet toestaat staan hier niet.',
    columns: {
      area: 'Gebied',
      request: 'Waar mensen om vroegen',
      count: 'Gevraagd',
      last_at: 'Laatst gevraagd',
      requests: 'Verzoeken',
    },
    count: '{{count}}×',
    see_requests_one: '{{count}} verzoek bekijken',
    see_requests_other: '{{count}} verzoeken bekijken',
    today: 'Vandaag, {{time}}',
    yesterday: 'Gisteren, {{time}}',
    empty_title: 'Geen verzoeken die Amigo niet kon uitvoeren',
    empty_text: 'Alles wat mensen vroegen, kon Amigo doen.',
  },
  areas: {
    menu: 'Menu',
    hours: 'Openingstijden',
    order_settings: 'Bestelinstellingen',
    my_info: 'Mijn gegevens',
    marketing: 'Marketing',
    gift_cards: 'Cadeaubonnen',
    reports: 'Rapporten',
    website: 'Website',
    integrations: 'Integraties',
    delivery: 'Bezorging',
    payments: 'Betalingen',
    team: 'Team',
    billing: 'Facturatie',
    settings: 'Instellingen',
    other: 'Overig',
  },
};
